import { render, staticRenderFns } from "./StaffPlanSchedulePage.vue?vue&type=template&id=6bd84bf8&scoped=true&"
import script from "./StaffPlanSchedulePage.vue?vue&type=script&lang=js&"
export * from "./StaffPlanSchedulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd84bf8",
  null
  
)

export default component.exports